<template>
  <div class="content-subsection">
    <h1>Alternate Option</h1>
    <h2>{{ subsection.option }}</h2>
    <div class="installation-desc mt-5">
      <v-rich-text-renderer :value="subsection.text" />
    </div>
    <div class="columns mt-5">
      <div class="column is-4 checked-list installation-list">
        <v-rich-text-renderer :value="subsection.list" />
      </div>
      <div class="column is-8">
        <img 
          :src="subsection.image.url" 
          :alt="subsection.image.name" 
          class="installation-method-img exception" 
        />
      </div>
    </div>
    <div v-if="subsection.summary" class="columns option-desc">
      <div class="column is-4">
        <div class="option-desc__label orange-dot">Alternative Pricing</div>
      </div>
      <div class="column is-8">
        <v-rich-text-renderer 
          :value="subsection.summary" 
        />
      </div>
    </div>
    <div v-if="subsection.note" class="columns option-desc">
      <div class="column is-4">
        <div class="option-desc__label orange-dot">Note</div>
      </div>
      <div class="column is-8">
        <div><span v-html="subsection.note"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import VRichTextRenderer from '../base/VRichTextRenderer'

export default {
  props: {
    subsection: {
      type: Object,
      required: true
    }
  },
  components: { VRichTextRenderer }
}
</script>

<style lang="scss" scoped>
.installation-desc {
  width: 75%;
}
.installation-list {
  font-size: 0.85em;
}
.installation-method-img {
  width: 100%;
  max-height: 500px;
  margin-top: 80px;
}

.option-desc {
  border-top: 1px solid #D5D3CE;
  font-weight: lighter;
  &__label {
    border-right: 1px solid #D5D3CE;
    height: 30px;
    font-size: 1.2em;
    font-weight: normal;
  }
  div.column {
    font-size: 0.75em;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .column > div {
    padding: 5px 10px;
  }
  &:not(:first-child) {
    margin-top: 3px !important;
  }
}
</style>

